import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "./hawk";

/**
 * Последний рубеж React: неотловленное исключение в дереве не оставляет
 * белый экран без следа. Текст — английский: это экран последней надежды,
 * i18n к этому моменту может быть уже мёртв, а фолбэк локали экосистемы — `en`.
 */
export class HawkErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
	state = { hasError: false };

	static getDerivedStateFromError(): { hasError: boolean } {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo): void {
		reportError(error, {
			source: "react-error-boundary",
			componentStack: info.componentStack,
		});
	}

	render(): ReactNode {
		if (this.state.hasError) {
			return (
				<main
					style={{
						fontFamily: "system-ui, sans-serif",
						padding: "2rem",
						maxWidth: "32rem",
						margin: "10vh auto",
					}}
				>
					<h1 style={{ fontSize: "1.25rem", fontWeight: 500 }}>Something went wrong</h1>
					<p style={{ color: "#5C6170" }}>
						Reload the page. If it happens again, try another browser.
					</p>
					<button type="button" onClick={() => window.location.reload()}>
						Reload
					</button>
				</main>
			);
		}
		return this.props.children;
	}
}
